var pharmacode = {};
export {
  pharmacode as __exports
};
//# sourceMappingURL=index180.js.map
